import { OrderLine } from "../../../../core/models/entities/Order";
import {
  GenericOrderLine,
  OrderLineHeaders,
  OrderLineHideColumns,
} from "./OrderLineData";

export interface OrderLineListProps {
  hideColumns?: OrderLineHideColumns;
  orderlines: OrderLine[];
  currency: string;
  showCustomerPrices?: boolean;
}

export function OrderLineList({
  hideColumns,
  orderlines,
  currency,
  showCustomerPrices,
}: OrderLineListProps) {
  // TODO Hack to remove pricePerPiece column.
  //  If this is ultimately desired, remove the pricePerPiece column from all OrderLine components.
  if (!hideColumns) hideColumns = { unitPrice: true };
  else hideColumns.unitPrice = true;

  return (
    <div className="max-h-[1000px] overflow-y-auto pr-2">
      <table
        className={
          "table-fixed border-collapse -sm:hidden empty-cells-hidden mx-auto w-full"
        }
      >
        <thead className={"uppercase"}>
          <OrderLineHeaders hide={hideColumns} />
        </thead>
        <tbody>
          {orderlines.map((orderline, i) => (
            <GenericOrderLine
              key={orderline.id}
              orderline={orderline}
              hide={hideColumns}
              currency={currency}
              isFirstItem={i === 0}
              showCustomerPrices={showCustomerPrices}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
